import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { MapItemEntity } from '../components/map-list/map-item.entity';
import { MapListEntity } from '../components/map-list/map-list.entity';
import { featureSelector, MapRootState } from './feature.store';
import { MapMainSliceState, MapSliceKey } from './map.state';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[MapSliceKey]
);

const listSelector = createSelector(baseSelector, (state) => state.list);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapById = (id: number) =>
	createSelector(listSelector, (list) => list.elements.get(`${id}`));

@Injectable()
export class MapSelector {
	public constructor(private readonly store: Store<MapRootState>) {}

	private get state(): Observable<MapMainSliceState> {
		return this.store.pipe(select(baseSelector));
	}

	public getLoading$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('loading')));
	}

	public getMapList$(): Observable<MapListEntity> {
		return this.store.pipe(select(listSelector));
	}

	public getSuccessDeleteMap$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('deleteSuccess')));
	}

	public getSelectedMaps$(
		selected: Array<string>
	): Observable<Array<MapItemEntity>> {
		return this.getMapList$().pipe(
			map((list) =>
				selected.reduce<Array<MapItemEntity>>((acc, curr) => {
					const maybe = list.elements.get(`${curr}`);
					if (maybe) {
						acc.push(maybe);
						return acc;
					}
					return acc;
				}, [])
			)
		);
	}
}
